<template>
    <div>
        <component
            :is="item.component"
            v-for="item in windows"
            :windowInfo="item.windowInfo"
           :key="item.registerName"></component>
    </div>
</template>
<style>
.demo-spin-col {
    overflow: hidden;
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}
</style>
<script>
import axios from 'axios';
import db from '../../js/communication/dbCommunicate';
export default {
    name: 'managerComponent',
    created: function () {
        this.$store.registerModule(['system', 'manager'], {
            state: {
                $: this
            }
        });
    },
    data: function () {
        return {
            dbCom: db,
            focusWindow: '',
            windows: [],
            showMenu: false,
            openList: []
        };
    },
    methods: {
        async isLock(winName, param) {
            var winData = null;
            var transaction = window.indexDBId.transaction(['projectObject']);
            var objectStore = transaction.objectStore('projectObject');
            var request = objectStore.getAll();
            // var request = objectStore.get(1);
            request.onsuccess = async function (event) {
                for (var k in request.result) {
                    for (var i in request.result[k]) {
                        if([i][0] == winName) {
                            winData = await this.createViewLock(winName, param, request.result[k][i], param);
                            if(winData) {
                                this.initView(winData, param);
                                return true;
                            } else {
                                return false;
                            }

                        }
                    }
                }
                winData = await this.createView(winName, param);
                await this.createLock(winName, winData);
                this.initView(winData, param);
            }.bind(this);
        },
        //创建窗口
        createLock(winName, winData) {
            //如果表格不存在，创建一个新的表格（keyPath，主键 ； autoIncrement,是否自增），会返回一个对象（objectStore）
            // objectStore就相当于数据库中的一张表。IDBObjectStore类型。
            var transaction = window.indexDBId.transaction(['projectObject'], 'readwrite');
            // 通过事务来获取IDBObjectStore
            var store = transaction.objectStore('projectObject');
            // 往store表中添加数据
            var addPersonRequest = store.add({
                [winName]: winData,
            });

            // 监听添加成功事件
            addPersonRequest.onsuccess = function (e) {
                console.log(e.target.result); // 打印添加成功数据的 主键（id）
            };

            // 监听失败事件
            addPersonRequest.onerror = function (e) {
                console.log(e.target.error);
            };
        },

        //打开某个窗口
        async openView(registerName, param, data,isb) {
            //打开窗口设置标签名称
            var labelSys = this.$store.state.system.$.labelSys;
            if(labelSys.labelNumber == 1) {
                document.title = registerName;//窗口名称
            }
            var winData = null;
            //只要是DisplayCom调用的函数就不会记录窗口位置
            if(data == 'DisplayCom') {
                this.$store.state.system.$.zoomList.y = 0;
                this.$store.state.system.$.zoomList.x = 0;
            }
            //判断是否是窗后退打开窗口
            if(param != 'header' && param != 'Template') {
                if(this.openList[this.openList.length - 1] != registerName) {
                    //维护打开窗口列表顺序
                    this.openList.push(registerName);
                }
            }
            if(this.$store.state.system.$.indexDB == null) {
                this.openViewName = 'windowComponent';
                this.appOpenViewName = 'appWindowComponent';
            } else {
                //获取浏览器的indexDB的是启用canvas还是svg
                if(this.$store.state.system.$.indexDB[0].isSvg) {
                    this.openViewName = 'windowComponentDiv';
                    this.appOpenViewName = 'appWindowComponentSvg';
                } else {
                    this.openViewName = 'windowComponent';
                    this.appOpenViewName = 'appWindowComponent';
                }
            }
            
            //请求数据
            //this.isLock(registerName,param);
            //是否启用高速缓存， 把数据存到indexDB里
            //返回值需要 用于单点趋势的 openview
            if(this.$store.state.system.$.indexDB != null) {
                if(this.$store.state.system.$.indexDB[0].isLocalCache) {
                    return this.isLock(registerName, param);
                } else {
                    var winData = await this.createView(registerName, param);
                    //判断是否是打开窗口成功  否则  返回false
                    if(winData) {
                        this.initView(winData, param,isb);
                        return true;
                    } else {
                        return winData;
                    }
                }
            }else{
               var winData = await this.createView(registerName, param);
                //判断是否是打开窗口成功  否则  返回false
                if(winData) {
                    this.initView(winData, param,isb);
                    return true;
                } else {
                    return winData;
                } 
            }
            
        },

        initView(view, param,isb) {
            if(param != 'header' && param != 'Template') {
                if(param == 0) {
                    param = 'portrait';
                } else if(param == 1) {
                    param = 'transverse';
                } else if(param == 2) {
                    param = 'selfAdaption';
                }else if(param == 3){
                    param = 'portraits';
                }
            }
            //用于判断app窗口调用DisplayCom的第二的参数的存储
            if(this.$store.state.system.manager[view.registerName]){
                this.$store.state.system.manager[view.registerName].$.turn = param;
            }
            this.fvScript.addFvObject(view.registerName);
            this.focusWindow = view.registerName;
            for (var p in this.$store.state.system.manager) {
                if(p == '$') continue;
                if(this.$store.state.system.manager[view.registerName]) {
                    //判断窗口是否是弹出式窗口
                    if(this.$store.state.system.manager[view.registerName].$.windowShowStyle == 1) {
                        return true;
                    }
                }
                if(this.$store.state.system.manager[p].$.autoclose && p != this.focusWindow) {
                    //如果是单点趋势不关闭窗口
                    if(param == 'Template') {
                        return true;
                    } else {
                        if(isb == undefined){
                            this.closeWindow(p);
                        }
                    }
                }
            }
        },
        async createViewLock(registerName, option, result) {
            return await new Promise((resolve, reject) => {
                var wContent = result;
                this.sendOpenViewDataList(wContent).then(() => {
                    this.windows.push({
                        'component': wContent.isApp ? this.appOpenViewName : this.openViewName,
                        'registerName': wContent.registerName,
                        'windowInfo': wContent
                    });
                    // this.wContentName = wContent.id;
                    resolve(wContent);
                }).catch(error => {
                    resolve(false);
                    console.log('窗口：' + registerName + '注册点失败');
                });
            });
        },
        //获取cookie值
        getCookie(name){
            var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
            if(arr=document.cookie.match(reg))
                return unescape(arr[2]);
            else
                return null;
        },
        async createView(registerName, option) {
            return await new Promise(async(resolve, reject) => {
                if(await this.$store.state.system.$.setDB()){
                     var tokey = await this.$store.state.system.$.setDB();
                }else{
                    var tokey = this.$store.state.system.$.cookieTokey;
                }
                axios.get(
                        window.debugFWebView + this.projectName + '/view/' + registerName + '.json',
                        { headers: {'X-Requested-With': 'XMLHttpRequest',tokey:tokey}
                    }).then(result => {
                    // console.log(result)
                    debug.log('准备获取窗口信息文件 -> ok');
                    if(result.data.error) {
                        if(option == 'Template') {
                            if(result.data.error == '无权限') {
                                resolve(false);
                            }
                        } else {
                            if(result.data.error == 'noUser') {
                                this.$store.state.system.$.toLogin();
                            } else {
                                //配置窗口 无权限
                                this.$Message.error(this.$store.state.system.$.getResource(result.data.error) || result.data.error);
                            }
                            reject(false);
                            return;
                        }
                    }
                    //使用url改变xy宽高全屏等
                    var wContent = result.data;
                    var url = location.search.substring(1);
                    var param = url.split('&');
                    var toUrlLogIn = false;
                    for (var i = 0; i < param.length; i++) {
                        var obj = decodeURIComponent(param[i]).split('=');
                        if(obj[0] == wContent.registerName) {
                            var str = eval('(' + obj[1] + ')');
                            for (var i in str) {
                                wContent[i] = str[i];
                            }
                        }
                    }
                    this.sendOpenViewDataList(wContent).then(() => {
                        this.windows.push({
                            'component': wContent.isApp ? this.appOpenViewName : this.openViewName,
                            'registerName': wContent.registerName,
                            'windowInfo': wContent
                        });
                        // this.wContentName = wContent.id;
                        resolve(wContent);
                    }).catch(error => {
                        resolve(false);
                        console.log('窗口：' + registerName + '注册点失败');
                    });
                }).catch(error => {
                    resolve(false);
                    this.$store.state.system.noWindow.$.show(true, '窗口：' + registerName + '不存在');
                });
            });
        },
        setProject(projectName) {
            this.projectName = projectName;
        },
        closeSingleView() {
            this.closeWindow(this.focusWindow);
        },
        //关闭某个窗口
        closeWindow(viewName) {
            if(this.$store.state.system.manager[viewName]) {
                this.$store.state.system.manager[viewName].$.onClose().then(() => {
                    //判断视频组件断开连接
                    if(this.$store.state.system.manager[viewName]['videoMonitor'] !== undefined) {

                        console.log(this.$store.state.system.manager[viewName]['videoMonitor']['$'].closePlayer());
                    }
                    delete this.$store.state.system.manager[viewName];
                    this.fvScript.deleteFvObject(viewName);
                    this.$store.unregisterModule(['system', 'manager', viewName]);
                    for (var i = 0; i < this.windows.length; i++) {
                        if(this.windows[i].registerName == viewName) {
                            this.windows.splice(i, 1);

                        }
                    }
                });
            }
        },

        //关闭所有窗口
        closeAllView() {
            for (var p in this.$store.state.system.manager) {
                if(p == '$') continue;
                this.$store.state.system.manager[p].$.onClose().then(() => {
                    delete this.$store.state.system.manager[p];
                });
                this.fvScript.deleteFvObject(p);
            }
            this.windows.splice(0, this.windows.length);

        },


        //隐藏某个窗口
        hideView(viewName) {
            if(this.$store.state.system.manager[viewName]) {
                this.$store.state.system.manager[viewName].$.isShow = false;
            }
        },
        monitor(obj) {
            Object.defineProperty(obj, 'FColor', {
                get: function () {
                    return this.color;
                },
                set: function (value) {
                    function zero_fill_hex(num, digits) {
                        var s = num.toString(16);
                        while (s.length < digits)
                            s = '0' + s;
                        return s;
                    }

                    function rgb2hex(rgb) {
                        if(rgb.charAt(0) == '#')
                            return rgb;
                        var ds = rgb.split(/\D+/);
                        var decimal = Number(ds[1]) * 65536 + Number(ds[2]) * 256 + Number(ds[3]);
                        return '#' + zero_fill_hex(decimal, 6);
                    }

                    if(value >= 0 && value < 2048) {
                        var defaultColor = FColorToRGB.getColors();
                        var colorTemp = defaultColor[value];
                        this.color = 'RGB(' + colorTemp[0] + ',' + colorTemp[1] + ',' + colorTemp[2] + ')';
                        if(this.renderType !== 0) {
                            if(this.renderConfig.color) {
                                this.renderConfig.color[0] = rgb2hex(this.color);
                            }
                        }
                    } else {
                        console.warn('颜色索引不存在');
                    }
                }
            });

            Object.defineProperty(obj, 'LColor', {
                get: function () {
                    return this.borderColor;
                },
                set: function (value) {
                    if(value >= 0 && value < 2048) {
                        var defaultColor = FColorToRGB.getColors();
                        var colorTemp = defaultColor[value];
                        this.borderColor = 'RGB(' + colorTemp[0] + ',' + colorTemp[1] + ',' + colorTemp[2] + ')';
                    } else {
                        console.warn('颜色索引不存在');
                    }
                }
            });

            Object.defineProperty(obj, 'X', {
                get: function () {
                    return this.x;
                },
                set: function (value) {
                    this.x = value;
                }
            });

            Object.defineProperty(obj, 'Y', {
                get: function () {
                    return this.y;
                },
                set: function (value) {
                    this.y = value;
                }
            });

            Object.defineProperty(obj, 'Width', {
                get: function () {
                    return this.width;
                },
                set: function (value) {
                    this.width = value;
                }
            });

            Object.defineProperty(obj, 'Height', {
                get: function () {
                    return this.height;
                },
                set: function (value) {
                    this.height = value;
                }
            });
        },
        //打印当前窗口
        toPrintView() {

        },

        setFocusWindow(name) {
            if(this.focusWindow != name) {
                if(this.$store.state.system.manager[this.focusWindow] == undefined) {
                    return;
                }
                this.$store.state.system.manager[this.focusWindow].$.cleanUpFource();
                this.focusWindow = name;
            }
        },

        getFocusWindow() {
            return this.$store.state.system.manager[this.focusWindow];
        },

        sendOpenViewDataList(view) {
            var dbVarList = [];
            for (var i = 0; i < view.dbVar.length; i++) {
                //拼接窗口数据库变量表单
                //dbVarList.push(view.dbVar[i].name.toUpperCase());//转成大写
                dbVarList.push(view.dbVar[i].name);
            }
            var data = {
                'head': 'openView',
                'dbVar': dbVarList
            };
            this.dbCom.declareTags(view.dbVar);
            if(view.varChangeAction != undefined) {
                view.varChangeAction.forEach(function (curAction) {
                    var varName = curAction.varName;
                    var varParStr = varName.replace(/^(.*)\.([^\.]+)/g, '$1');
                    var varLastStr = varName.replace(/^(.*)\.([^\.]+)/g, '$2');

                    var varPar = lang.getObject(varParStr, true);
                    if(varPar != undefined) {
                        var varChangeListStr = varParStr + '.varChangeFuncList';
                        var varChangeList = lang.getObject(varChangeListStr, true);
                        varChangeList[varLastStr] = fcFunction(curAction.changeAction);
                    }
                }.bind(this));
            }
            return new Promise((resolve) => {
                this.dbCom.sendMessage(data, resolve);
            });
        },
    }
};
</script>




// WEBPACK FOOTER //
// src/components/system/managerComponent.vue